<template>
  <div class="hello" style="background-color:#f4f5f5; height:auto; padding-bottom: 180px;">
    <van-sticky class="item-pop">
      <div style="position: relative; max-width: 640px; left:auto; margin: 0 auto;">
        <van-nav-bar style="height:40px;background: rgb(53, 120, 229)" :border="false" @click-left="onClickLeft">
          <template #left>
            <van-icon style=" font-weight: 900;" name="arrow-left" color="#FFFFFF" size="25"/>
          </template>
          <template #title>
            <span style="color:#FFFFFF; font-weight: 700; font-size: 19px;">訂單資料</span>
          </template>
        </van-nav-bar>
      </div>
    </van-sticky>
    <div style="max-width: 640px; background: rgb(53, 120, 229); left:auto; margin: 0 auto;height: 130px; border-radius: 0% 0% 50% 50%;">
      <div style="margin-left:15px; display: inline-flex">
      </div>
    </div>
    <van-cell-group style="border-radius:10px; margin-top:-100px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto; min-height: 100px;" size="large" :border="false">
        <template>
          <span class="Details-title">訂貨清單</span>
          <van-tabs v-model="active" animated color="rgb(53, 120, 229)" swipeable @change="changeStatus">
            <van-tab title="處理中" name="1"></van-tab>
            <van-tab title="配貨中" name="2"></van-tab>
            <van-tab title="待收貨" name="3"></van-tab>
            <van-tab title="已收貨" name="4"></van-tab>
            <van-tab title="已拒收" name="-2"></van-tab>
            <van-tab title="已作廢" name="-1"></van-tab>
          </van-tabs>
          <van-empty
            v-if="list.length === 0"
            description="暫無訂單，請您繼續選購~"
          />
        </template>
      </van-cell>
    </van-cell-group>
    <van-cell-group v-for="(item,index) in list.slice((currentPage-1)*5,currentPage*5)" :key="index" style="border-radius:10px; margin-top:10px; margin-left:20px; margin-right:20px;" :border="false">
      <van-cell style="border-radius:10px; height:auto;" size="large" :border="false">
        <template>
          <div>
          <span style="position:relative; text-align: left;">{{item.un}}</span>
          <span style="position:absolute; text-align: right; right:5px;">{{item.date}}</span>
          </div>
          <van-cell v-for="(set,i) in item.uid" :key="i" style=" min-height: 80px; background-color: #f5f5f5f8; margin-top: 10px;">
              <template #icon>
                <van-image style="position: relative; left: -10px; width:70px; height: 70px;"  :src="item.banner[i]"/>
              </template>
              <template #title>
                <span style="position: relative; top: -10px; font-size: 14px;"> {{ item.ItemTitle[i] }}</span>
              </template>
              <template #label>
                <div style="position: relative; top: -15px; text-align:left;">
                  <van-collapse v-model="activeNames[index]"  :border="false" accordion>
                    <van-collapse-item :name="item.uid[i]" style="border-radius:50px;">
                      <template #title>
                        <span style="font-size: 11px; margin-left: -15px;"> {{ item.packageName[i] }}</span>
                      </template>
                      <template>
                        <span style="font-size: 11px;"> {{ item.content[i] }}</span>
                      </template>
                    </van-collapse-item>
                  </van-collapse>
                </div>
              </template>
              <template #right-icon>
                <span style="position:absolute; text-align: right; right: 10px; bottom: 0px; font-weight: 700; color: rgb(53, 120, 229)"> {{ item.currency[i] }}$ {{ item.price[i] }}</span>
              </template>
            </van-cell>
      <van-cell style=" height: 50px; background-color: #f5f5f5f8; margin-top: 10px;" :border="false">
        <template #title>
          <span style="position:absolute; text-align: left; left: 10px; top: 5px; font-size: 12px;"> 物流廠商：<span style="color: rgb(53, 120, 229); font-weight:700;">{{item.express}}</span></span>
          <span style="position:absolute; text-align: right; right: 10px; top: 5px; font-size: 12px;"> 共計<span style="color: rgb(53, 120, 229); font-weight:700;">{{item.uid.length}}</span>件商品</span>
        </template>
        <template #right-icon>
          <span style="position:absolute; text-align: left; left: 10px; top: 25px; font-size: 12px;"> 物流編號：<span style="color: rgb(53, 120, 229); font-weight:700;">{{item.tracking}}</span></span>
          <span style="position:absolute; text-align: right; right: 10px; top: 25px; font-size: 12px;"> 總價：<span style="color: rgb(53, 120, 229); font-weight:700;">NT$ {{item.total}}</span></span>
        </template>
      </van-cell>
          </template>
        </van-cell>
    </van-cell-group>
    <div style="margin-top:10px;">
      <van-pagination style="margin: 0 auto; max-width:200px; text-align: center;" v-model="currentPage" :total-items="list.length" :show-page-size="5">
        <template #prev-text>
          <van-icon name="arrow-left" />
        </template>
        <template #next-text>
          <van-icon name="arrow" />
        </template>
        <template #page="{ text }">{{ text }}</template>
      </van-pagination>
    </div>
    <van-divider>爲您推介</van-divider>
    <van-cell-group style="border-radius:20px; margin-top:20px; margin-left:7px; margin-right:7px;" :border="false">
      <van-cell style="margin-top:5px; border-radius:20px;" :border="false" size="large" >
        <template>
          <span class="Details-title"><van-icon name="fire-o" />好物推介</span>
        </template>
      </van-cell>
      <van-cell class="recomm-cell" :border="false" size="large">
        <van-grid :column-num="2" clickable :border="false" >
          <van-grid-item v-for="(item,index) in recomm" :key="index" @click="gotoItem(item.ShortLink)">
            <div style="width:100%; height: 10rem;">
              <van-image width="100%" height="100%" :src="item.banner" fit="fill"/>
            </div>
            <div style="height:40px; display:inline">
              <p style="float:left;  font-size:0.5rem;font-weight:900; line-height: 0.6rem; ">{{ item.ItemTitle }}</p>
            </div>
            <div style="width:100%;height:20px;">
              <span style="float:left; font-size:0.7rem; font-weight:900;color: #3578e5;">{{ item.Currency }}${{ item.Price }}起</span>
              <span style="float:right; font-size:0.7rem;color: gray;">售出：{{ item.sales }}</span>
            </div>
          </van-grid-item>
        </van-grid>
      </van-cell>
    </van-cell-group>
    <div style="margin-top:20px; padding-bottom:50px;">
      <van-collapse v-model="activeNames">
        <van-collapse-item title="用戶須知" name="1">本產品的實際使用效果根據個人情況決定，不保證每位用戶都能享受到所宣傳的效果。若有疑問請通過在線客服聯絡我們，本公司享有最終解釋權。</van-collapse-item>
        <van-collapse-item title="物流配送" name="2">貨物一般在訂單確認的5~10個工作日送達，出現突發狀況可能會有所延遲。貨物送達前都會提前聯絡客戶，請保持電話暢通。</van-collapse-item>
        <van-collapse-item title="退貨流程" name="3">確認收貨—申請退換貨—客服審核通過—用戶寄回商品—倉庫簽收驗貨—退換貨審核—退款/換貨；退換貨請註明：訂單號、姓名、電話。</van-collapse-item>
        <van-collapse-item title="關於我們" name="4">小泉士多致力於為客戶提供優質的商品，並以此爲目標不斷努力。爲了保障您的權益，購物前請認準我們的官方網站和社交媒體。</van-collapse-item>
        <van-collapse-item title="聯絡我們" name="5">如果您有問題需要幫助，可以通過在線客服與我們聯絡，或前往我們的Facebook主頁。客服電郵：support@koizumishop.com</van-collapse-item>
      </van-collapse>
    </div>
    <div style="margin:0 auto; text-align:center; padding-bottom:80px;">
      <span style="color: #606266; font-size:0.6rem;">@小泉士多 KOIZUMISHOP</span>
      <div style="margin-top:20px;">
        <ul style="display: inline-flex;list-style: none;"><li style="margin-right: 14px;"><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/privacy">隱私政策</a></li><li><a style="color:#606266; text-decoration: none;font-size:0.6rem;" href="/terms">服務條款</a></li></ul>
      </div>
    </div>
<!--     <van-tabbar style="max-width:640px; bottom:0px; position:fixed" v-model="active" :fixed="false">
      <van-tabbar-item icon="home-o" @click="gotohome()">首頁</van-tabbar-item>
      <van-tabbar-item icon="shopping-cart-o">商品</van-tabbar-item>
      <van-tabbar-item icon="search">訂單</van-tabbar-item>
      <van-tabbar-item icon="service-o" @click="openchat()">客服</van-tabbar-item>
    </van-tabbar> -->
  </div>
</template>
<script>
import { findOrder } from '@/api/order'
import { Notify, Toast } from 'vant'
import { getItemRecommend } from '@/api/item'
import { getUser } from '@/utils/auth'
export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      activeNames: [['1'], ['1']],
      list: [],
      recomm: [],
      active: 0,
      status: 1,
      currentPage: 1,
      orderForm: {sn: '', phone: ''}
    }
  },
  created () {
    this.initPixel()
    this.getRecommendInfo()
    this.findOrder()
  },
  mounted () {
    setTimeout(() => {
      this.sharkFlag = true
    }, 5000)
  },
  methods: {
    initPixel () {
      window.fbq('init', '519571556714129')
      window.fbq('track', 'PageView')
      window.fbq('track', 'ViewContent')
    },
    changeStatus (e) {
      this.status = e
      this.findOrder()
    },
    findOrder () {
      this.list = []
      Toast.loading({
        message: '請稍後...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 250
      })
      findOrder({ customer: getUser(), status: this.status }).then(res => {
        if (res.code === 200) {
          this.list = res.data
          for (var i = 0; i < this.list.length; i++) {
            this.activeNames[i] = ['1']
          }
        } else {
          Notify({ type: 'danger', message: res.message })
        }
      })
    },
    getRecommendInfo () {
      Toast.loading({
        message: '加載中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 3000
      })
      getItemRecommend({ code: '', nums: 12 }).then(res => {
        if (res.code === 200) {
          this.recomm = []
          this.recomm = res.data
          Toast.clear()
        } else {
          Toast.fail('加載出錯，請刷新重試')
        }
      })
    },
    onSubmit () {
      this.$refs.Form.validate().then(() => {
        // 验证通过
      }).catch(() => {
        Notify({ type: 'warning', message: '請完善訂單資料' })
        const returnEle = document.querySelector('#deliver')
        returnEle.scrollIntoView(true)
      })
    },
    openchat () {
      window.fbq('track', 'Contact')
      window.open('https://m.me/107590398670276', '_blank')
    },
    onClickLeft () {
      this.$router.back(-1)
      window.scrollTo(0, 0)
    },
    gotohome () {
      this.$router.push('/')
      window.scrollTo(0, 0)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.Price-title {
    margin-right: 4px;
    vertical-align: middle;
    color: #3578e5;
    float: left;
    font-weight: 700;
    font-size: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Order.vue